module.exports = __webpack_public_path__ + "static/plan-bonus-120000b9c41e7b8a1a4bc116b2b644f9.png";